<template>
  <el-dialog
    :title="isCreate ? '新增代理商' : '编辑代理商'"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="450px"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item label="代理商登录名" prop="agentLoginAccount">
        <el-input v-model.trim="ruleForm.agentLoginAccount"></el-input>
      </el-form-item>
      <template v-if="isCreate">
        <el-form-item label="密码" prop="password">
          <el-input
            v-model.trim="ruleForm.password"
            maxlength="16"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repeatpassword">
          <el-input
            v-model.trim="ruleForm.repeatpassword"
            maxlength="16"
            type="password"
          ></el-input>
        </el-form-item>
      </template>
      <el-form-item label="代理商名称" prop="agentName">
        <el-input v-model.trim="ruleForm.agentName"></el-input>
      </el-form-item>
      <el-form-item label="代理商联系人" prop="agentContact">
        <el-input v-model.trim="ruleForm.agentContact"></el-input>
      </el-form-item>
      <el-form-item label="代理商手机" prop="agentMobile">
        <el-input v-model.trim="ruleForm.agentMobile"></el-input>
      </el-form-item>
      <el-form-item label="所在城市" prop="agentCity">
        <el-select v-model="ruleForm.agentCity" placeholder="请选择">
          <el-option
            v-for="(item, index) in CITY_ENUM"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <div class="align-center">
        <el-button type="primary" @click="submitForm()">确定</el-button>
        <el-button type="warning" v-if="!isCreate" @click="resetPassword()"
          >重置密码</el-button
        >
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import enumObject from "../../../plugins/enum";
export default {
  props: ["isCreate", "editInfo"],
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.password !== "") {
          this.$refs.ruleForm.validateField("validatePass2");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        agentLoginAccount: this.editInfo ? this.editInfo.agentLoginAccount : "",
        password: "",
        repeatpassword: "",
        agentName: this.editInfo ? this.editInfo.agentName : "",
        agentContact: this.editInfo ? this.editInfo.agentContact : "",
        agentMobile: this.editInfo ? this.editInfo.agentMobile : "",
        agentCity: this.editInfo ? this.editInfo.agentCity : ""
      },
      rules: {
        agentLoginAccount: [{ required: true, message: "请输入代理商登录名" }],
        password: [
          { required: true, validator: validatePass },
          {
            pattern: /^.*(?=.{6,16})(?=.*[0-9a-zA-Z]{1,})(?=.*[!@#$%^&*?()]).*$/,
            message: "密码必须6-16位，至少包含1个特殊字符(!@#$%^&*)"
          }
        ],
        repeatpassword: [{ required: true, validator: validatePass2 }],
        agentName: [{ required: true, message: "请输入代理商名称" }],
        agentContact: [{ required: true, message: "请输入代理商联系人" }],
        agentMobile: [
          { required: true, message: "请输入代理商手机" },
          {
            validator: (rule, value, callback) => {
              if (!/^1\d{10}$/.test(value)) {
                return callback(new Error("请输入正确的手机号码"));
              } else {
                return callback();
              }
            }
          }
        ],
        agentCity: [{ required: true, message: "请输入所在城市" }]
      }
    };
  },
  methods: {
    resetPassword() {
      const _password = this.generatePassword(7) + "!";
      this.$confirm("密码将重置为【" + _password + "】,是否继续？", "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$refs["ruleForm"].validate(valid => {
            if (valid) {
              let queryModel = {
                agentPassword: _password,
                id: this.editInfo.id
              };
              this.$axios(this.$urlMapping["编辑代理商"], {
                data: queryModel
                // eslint-disable-next-line no-unused-vars
              }).then(result => {
                this.$message({
                  message: `密码已重置成功，初始密码为：${_password}`,
                  type: "success",
                  showClose: true,
                  duration: 0
                });
                this.$emit("closeForm");
                this.$emit("handleUpdate");
              });
            } else {
              console.log("error submit!!");
              return false;
            }
          });
        })
        .catch(() => {});
    },
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let queryModel = {
            agentLoginAccount: this.isCreate
              ? this.ruleForm.agentLoginAccount
              : undefined,
            agentName: this.ruleForm.agentName,
            agentPassword: this.isCreate ? this.ruleForm.password : undefined,
            agentContact: this.ruleForm.agentContact,
            agentMobile: this.ruleForm.agentMobile,
            agentCity: this.ruleForm.agentCity,
            id: this.isCreate ? undefined : this.editInfo.id
          };
          let key = this.isCreate ? "新增代理商" : "编辑代理商";
          this.$axios(this.$urlMapping[key], {
            data: queryModel
            // eslint-disable-next-line no-unused-vars
          }).then(result => {
            this.$notifySuccess();
            this.$getAllAgentIDName(); //刷新全局数据

            this.$emit("closeForm");
            this.$emit("handleUpdate");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeForm() {
      this.$emit("closeForm");
    },
    generatePassword(length) {
      var result = "";
      var characters =
        "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789"; //去除0O1l等易混淆字符
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    }
  },
  computed: {
    CITY_ENUM() {
      return enumObject.CITY_ENUM.filter(ele => ele.value != "");
    }
  }
};
</script>

<style lang="less" scoped></style>
